/* LE TIROIR DU PANIER SE TIRE VERS LE BAS POUR SE FERMER (téléphone).
 *
 * Décision du client (06/09/2026, maquette V6 « Le volet qu'on tire vers le
 * bas ») : sur téléphone, le panier est un volet posé sur la page, qu'on voit
 * encore derrière, assombrie ; une poignée en haut ; on tire vers le bas, ça
 * se ferme. Rien d'autre ne change dans le tiroir.
 *
 * LE GESTE NE PART QUE DU HAUT DU VOLET (client, 06/09/2026 au soir : « il
 * faut vraiment qu'il l'attrape »). La zone de prise est invisible : la
 * poignée, l'en-tête « Panier », et tout ce qui est à moins de ZONE px du
 * bord haut du volet. Ailleurs, le doigt fait défiler, jamais fermer.
 *
 * LE MOUVEMENT EST NATUREL (client, 06/09/2026, nuit) : le volet suit le
 * doigt ; au lâcher, s'il est descendu de plus de la moitié de sa hauteur
 * (ou lancé vite vers le bas), il CONTINUE de glisser jusqu'en bas puis se
 * ferme, sans jamais remonter d'abord ; sinon il remonte en place. La
 * fermeture du thème se fait ensuite sans son animation à elle (classe
 * theme-drawer__dialog-instant), le volet étant déjà en bas.
 *
 * LA CROIX RÉPOND AU GESTE (client, 07/09/2026) : pendant qu'on tire, le
 * bouton de fermeture grossit, tourne et se teinte d'ambre, de plus en plus
 * à mesure qu'on approche du point de fermeture — le geste et la croix font
 * la même chose, on le comprend en le faisant.
 *
 * Un seul écouteur sur le document : il survit à tous les redessins du tiroir.
 * La feuille de style qui pose le volet est dans snippets/cart-drawer.liquid.
 */
if (!window.__ycTiroirGlisser) {
  window.__ycTiroirGlisser = true;
  const surTelephone = () => window.matchMedia('(width < 750px)').matches;
  const ZONE = 110;
  const VITESSE_LANCER = 0.7; /* px par ms : un coup sec vers le bas ferme aussi */

  const croixDe = (dialog) => dialog.querySelector('.theme-drawer__close-button');
  const animerCroix = (croix, avancement) => {
    if (!croix) return;
    croix.style.transition = 'none';
    croix.style.transform = 'scale(' + (1 + 0.4 * avancement).toFixed(3) + ') rotate(' + Math.round(90 * avancement) + 'deg)';
    croix.style.backgroundColor = 'rgba(232, 150, 46, ' + (0.12 + 0.7 * avancement).toFixed(2) + ')';
  };
  const reposerCroix = (croix) => {
    if (!croix) return;
    croix.style.transition = 'transform 0.22s ease-out, background-color 0.22s ease-out';
    croix.style.transform = '';
    croix.style.backgroundColor = '';
    setTimeout(() => {
      croix.style.transition = '';
    }, 260);
  };

  document.addEventListener(
    'touchstart',
    (depart) => {
      if (!surTelephone() || depart.touches.length !== 1) return;
      const cible = depart.target instanceof Element ? depart.target : null;
      if (!cible) return;
      const dialog = cible.closest('#cart-drawer dialog[open]');
      if (!dialog) return;
      const doigt = depart.touches[0];
      const dansLaPrise =
        cible.closest('.yc-poignee, .theme-drawer__header') ||
        doigt.clientY - dialog.getBoundingClientRect().top <= ZONE;
      if (!dansLaPrise) return;
      if (cible.closest('button, a, input')) return;

      const croix = croixDe(dialog);
      const hauteur = dialog.getBoundingClientRect().height || 1;
      const y0 = doigt.clientY;
      let dy = 0;
      let dernierY = y0;
      let dernierT = depart.timeStamp;
      let vitesse = 0;

      const bouge = (e) => {
        const y = e.touches[0].clientY;
        const dt = e.timeStamp - dernierT;
        if (dt > 0) vitesse = (y - dernierY) / dt;
        dernierY = y;
        dernierT = e.timeStamp;
        dy = y - y0;
        dialog.style.transition = 'none';
        dialog.style.transform = dy > 0 ? 'translateY(' + Math.round(dy) + 'px)' : '';
        animerCroix(croix, Math.max(0, Math.min(1, dy / (hauteur / 2))));
        if (e.cancelable) e.preventDefault();
      };

      const fin = () => {
        document.removeEventListener('touchmove', bouge);
        document.removeEventListener('touchend', fin);
        document.removeEventListener('touchcancel', fin);
        const ferme = dy > hauteur / 2 || (dy > 60 && vitesse > VITESSE_LANCER);
        dialog.style.transition = 'transform 0.22s ease-out';
        if (!ferme) {
          /* Remonte en place, en glissant ; la croix reprend sa forme. */
          dialog.style.transform = '';
          reposerCroix(croix);
          const range = () => {
            dialog.style.transition = '';
            dialog.removeEventListener('transitionend', range);
          };
          dialog.addEventListener('transitionend', range);
          setTimeout(range, 320);
          return;
        }
        /* Continue jusqu'en bas, la croix pleine, puis ferme sans remonter. */
        animerCroix(croix, 1);
        let fait = false;
        const termine = () => {
          if (fait) return;
          fait = true;
          dialog.removeEventListener('transitionend', termine);
          dialog.style.transition = '';
          dialog.classList.add('theme-drawer__dialog-instant');
          dialog.addEventListener(
            'close',
            () => {
              dialog.style.transform = '';
              dialog.classList.remove('theme-drawer__dialog-instant');
              const c = croixDe(dialog);
              if (c) {
                c.style.transition = '';
                c.style.transform = '';
                c.style.backgroundColor = '';
              }
            },
            { once: true }
          );
          const tiroir = document.getElementById('cart-drawer');
          if (tiroir && typeof tiroir.close === 'function') tiroir.close();
          else dialog.close();
        };
        dialog.addEventListener('transitionend', termine);
        setTimeout(termine, 320);
        void dialog.offsetHeight;
        dialog.style.transform = 'translateY(100%)';
      };

      document.addEventListener('touchmove', bouge, { passive: false });
      document.addEventListener('touchend', fin);
      document.addEventListener('touchcancel', fin);
    },
    { passive: true }
  );
}
